exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Organizations-b94a5693{background:#FFF;max-width:100%;display:flex;flex-wrap:wrap;align-items:center;padding:15px}.Organizations-b94a5693.collapsed-eed33fdd{justify-content:space-around}.organization-f4a25f1b{display:flex;align-items:center;height:44px;margin:5px 0px;flex-grow:1;flex-shrink:0;flex-basis:44px;justify-content:center;max-width:50px}\n", ""]);

// Exports
exports.locals = {
	"Organizations": "Organizations-b94a5693",
	"collapsed": "collapsed-eed33fdd",
	"organization": "organization-f4a25f1b"
};